<template>
  <div>
    <b-overlay :show="loading">
        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">Daily Attendance on {{ date }}
                    <span class="title-sub-text">View and make adjustments to daily employee attendance details.</span>
                </span>
                <span class="float-right"></span>
            </h4>
        </div>
        <div class="d-flex justify-content-between flex-row align-items-end">
                <div class="align-self-center custom-search pr-0 mt-2" >
                    <b-input-group>
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search" v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>

                <div class="d-flex flex-row justify-content-end align-content-end">
                  <b-form-row>
                    <b-col :cols="flag ? 10:9" class=" d-flex flex-row align-items-end justify-content-end">
                      <b-dropdown v-if="flag"  class="mr-2" id="dropdown-export" v-b-tooltip.hover.top="'Download today’s attendance template.'">
                        <template #button-content>
                          <b-icon icon="code-slash"></b-icon> Attendance Template
                        </template>

                        <b-dropdown-item @click="downloadTemplate(1,selected, date)">
                          <b-icon icon="code-slash" class="pr-1"></b-icon> Attendance Template For Selected Employees
                        </b-dropdown-item>
                        <b-dropdown-item @click="downloadTemplate(2, [],date)">
                          <b-icon icon="code-slash" class="pr-1"></b-icon> Attendance Template for All Employees
                        </b-dropdown-item>
                      </b-dropdown>
                      <b-button v-if="flag" @click="openAttendanceFileModal" variant="secondary" class="custom-secodary-btn mr-2" v-b-tooltip.hover.top="'Import today’s attendance template.'"><b-icon icon="upload"></b-icon> Device File</b-button>
                      <b-button v-if="flag" @click="openModal" variant="secondary" class="custom-secodary-btn mr-2" v-b-tooltip.hover.top="'Import today’s attendance template.'"><b-icon icon="upload"></b-icon> Import Template</b-button>
                      <b-button class="mr-2" @click="downloadData(date)" v-b-tooltip.hover.top="'Download daily report for the selected date'"><b-icon icon="download"></b-icon> Download Report</b-button>
                      <b-button class="employee-filter-btn custom-secodary-btn" v-b-toggle.sidebar-filter>Filter<b-icon class="ml-3" icon="funnel-fill" ></b-icon></b-button>
                    </b-col>
                    <b-col :cols="flag ? 2:3">
                      <b-input-group class="date-range-picker d-flex flex-row align-items-end justify-content-start mb-0" style="margin-top: 2px;">
                        <b-form-group id="date-group" label-for="date" class="mb-0">
                          <b-input-group class="mb-0">
                            <b-form-input @input="loadData(date)" id="date" name="date" v-model="date" v-validate="{  }" type="text" placeholder="YYYY-MM-DD"
                                          autocomplete="off" :state="validateState('date')" aria-describedby="date-feedback" data-vv-as="Date"/>
                            <b-input-group-append class="mb-0">
                              <b-form-datepicker v-b-tooltip.hover.top="'Select a date to preview the daily report.'" @input="loadData(date)" class="mb-0" id="day_two" button-only right locale="en-US" v-model="date" />
                            </b-input-group-append>
                            <b-form-invalid-feedback id="date-feedback">
                              {{ veeErrors.first('date') }}
                            </b-form-invalid-feedback>
                          </b-input-group>
                        </b-form-group>
                      </b-input-group>
                    </b-col>
                  </b-form-row>
                </div>
              </div>


        <b-sidebar id="sidebar-filter" title="Filter" right shadow>
          <template v-slot:default="{ hide }">
            <div class="px-3 py-2">

              <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="list"></b-icon>
                </b-input-group-prepend>
                <b-form-select plain :options="shifts" v-model="shift">
                  <template #first>
                    <b-form-select-option :value="null">Select Office Time Settings</b-form-select-option>
                  </template>
                </b-form-select>
              </b-input-group>

              <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                    <b-icon icon="list"></b-icon>
                </b-input-group-prepend>
                <b-form-select plain :options="statusOptions" v-model="status">
                    <template #first>
                    <b-form-select-option :value="null">Select Status</b-form-select-option>
                    </template>
                </b-form-select>
              </b-input-group>


              <div class="row">
                <div class="col-6">
                  <b-button class="filter_btn" variant="primary" block title="Set Filter"  @click="setFilter();"><div>Set Filter</div></b-button>
                </div>
                <div class="col-6">
                  <b-button class="filter_btn" variant="primary" block title="Clear Filter" @click="resetFilter();"><div>Clear Filter</div></b-button>
                </div>
              </div>
            </div>
          </template>
        </b-sidebar>

        <div class="mt-3">
          <b-alert show v-for="(err, index) in errors" :key="index" variant="danger">{{err}}</b-alert>
        </div>

        <div class="table-responsive employee-table-wrapper mt-3">
        <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
          <thead class="table-head">
          <tr class="table-head">
            <td class="checkbox-col">
              <input type="checkbox" v-model="selectAll" class="px-3"></input>
              <label for=""></label>
            </td>
            <th class="cursor-pointer" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'">
                <span>{{column.label}}</span>
              </th>
            </tr>
          </thead>

          <tbody>
          <tr v-b-tooltip.hover.top="row.data_source" v-for="row in paginatedData" :key="row.id" class="hover-bg table-row border-bottom mx-2 cursor-pointer">
            <td class="checkbox-col">
              <input v-model="selected" :value="row.id" type="checkbox" class="px-3"></input>
              <label for=""></label>
            </td>
            <td @click="showEmployee(row)">
              <div class="d-flex align-items-center">
                <div class="avatar-circle mr-2">
                  <img class="img-fluid img-thumbnail employee-avatar mx-2" :src="$api_url+'/avatar/'+row.company_id+'/'+row.pic" alt="">
                </div>
                <div>
                  <div class="fw-600">{{ row.name }}</div>
                </div>
              </div>
            </td>

            <td :class="{'text-center' : !row.employee_code}" @click="showEmployee(row)">{{ row.employee_code || '-' }}</td>
            <td :class="{'text-center' : !row.department}" @click="showEmployee(row)">{{ row.department || '-' }}</td>
            <td :class="{'text-center' : !row.jobposition}" @click="showEmployee(row)">{{ row.jobposition || '-' }}</td>
            <td :class="{'text-center' : !row.branch}" @click="showEmployee(row)">{{ row.branch || '-' }}</td>

            <td @click="showEmployee(row)" v-if="roster == 1" class="text-center">
                  <span class="shift-badge py-1 px-3 rounded text-nowrap" :style="{ background: row.shift.color + '22', color: row.shift.color }">{{ row.shift_name }}</span>
            </td>

            <td @click="showEmployee(row)" v-if="roster == 1">
              <span v-if="row.shift">{{ row.shift_time }}</span>
              <span v-else>-</span>
            </td>

            <td :class="{'text-center' : row.check_in == '-'}" @click="showEmployee(row)">{{row.check_in}}</td>
            <td :class="{'text-center' : row.check_out == '-'}" @click="showEmployee(row)">{{row.check_out}}</td>
            <td :class="{'text-center' : row.work_time == '-'}" @click="showEmployee(row)">{{row.work_time}}</td>

            <td @click="showEmployee(row)" class="text-center">
              <span class="shift-badge py-1 px-3 rounded text-nowrap" :style="{ background: row.status_color + '22', color: row.status_color }">
                {{row.status }}
              </span>
            </td>
          </tr>
          </tbody>

        </table>

        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
        <div v-else class="px-3 mt-4">
          <ul class="pagination b-pagination float-left mb-0 mt-1">
            <li class="page-item disabled m-2">View</li>
            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
            <li class="page-item disabled m-2">per page. Total {{assignments.length}} records found.</li>
          </ul>
          <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

        </div>
      </div>
    </b-overlay>


    <b-modal id="activity_logModal" size="xl" scrollable  hide-footer>
      <template #modal-title>
        <div class="d-flex flex-row align-items-center">
          <div class="mr-3" :style="{height: '25px',width: '25px', background: shift_color, borderRadius: '50%'}"></div> <span>Attendance Info at {{shift_name}}</span>
        </div>
      </template>
      <div class="row no-margin">
        <div class="col-md-6">
          <div class="card punch-status">
            <div class="card-body">
              <h5 class="card-title">Timesheet <small class="text-muted">{{attendances_date}}</small></h5>
              <div class="punch-det">
                <h6>Punch In at</h6>
                <p>{{check_in}}</p>
              </div>
              <div class="punch-info">
                <div class="punch-hours">
                  <span>{{work_time}}</span>
                </div>
              </div>
              <div class="punch-det">
                <h6>Punch Out at</h6>
                <p>{{check_out}}</p>
              </div>
              <div class="punch-det">
                <h6>Overtime</h6>
                <p>{{over_time}}</p>
              </div>
              <div class="punch-det">
                <h6>Break Time</h6>
                <p>{{break_time}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card recent-activity">
            <div class="card-body">
              <h5 class="card-title">Activity</h5>
              <ul class="res-activity-list" v-if="activity_log">
                <li v-for="(activity, index) in activity_log">
                  <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                  <p class="mb-0" v-else>Punch Out at</p>
                  <p class="res-activity-time">
                    <i class="far fa-clock"></i>
                    {{ moment(activity, "YYYY-MM-DD HH:mm:ss").format("hh:mm A") }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="bv-modal-import-roster" title="Upload Roster File" hide-footer>
      <div class="modal-body-custom">
        <h5 class="mb-3">Upload Roster File</h5>
        <b-form-file id="datafile" @change="onFileChange" v-model="selectedFile" browse-text="Browse" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="mr-2" @click="closeModal">Cancel</b-button>
          <b-button variant="primary" :disabled="!selectedFile" @click="importFile">Import</b-button>
        </div>
      </div>
    </b-modal>


    <b-modal id="bv-modal-import-attendance" title="Upload CSV File From Device" hide-footer>
      <div class="modal-body-custom">
        <h5 class="mb-3">Upload CSV File From Device</h5>
        <b-form-file @input="onFileChange" v-model="selectedFile" browse-text="Browse" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" class="mr-2" @click="closeModal">Cancel</b-button>
          <b-button variant="primary" :disabled="!selectedFile" @click="importFile(1)">Import</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>


<script>
import moment from "moment";

export default {
  props: ['flag', 'roster'],
  data() {
    let sortOrders = {};
    let columns = [
      {label: 'Employee Name', name: 'name' },
      {label: 'Employee Code', name: 'employee_code' },
      {label: 'Department', name: 'department' },
      {label: 'Job Position', name: 'jobposition' },
      {label: 'Work Location', name: 'branch' },
      {label: 'Shift Assignment', name: 'shift_name', type: 'text' },
      {label: 'Shift Time', name: 'shift_time', type: 'text' },
      {label: 'Check In', name: 'check_in' },
      {label: 'Check Out', name: 'check_out' },
      {label: 'Work Time', name: 'work_time' },
      {label: 'Status', name: 'status' },
    ];

    columns.forEach((column) => {sortOrders[column.name] = -1;});
    return {
      search: '',
      columns:columns,
      sortOrders:sortOrders,
      sortKey:'name',
      index: 0,
      list_key: 1,
      selected: [],
      shifts: [],
      shift: null,
      company_options: [],
      custom_list: [],
      date: new Date().toISOString().slice(0, 10),
      assignments: [],
      activity_log: [],
      attendances_date:'',
      shift_name: '',
      shift_color: '',
      check_in:'',
      check_out:'',
      work_time:'',
      over_time:'',
      break_time:'',
      loading: false,
      error: null,
      errors: [],
      selectedFile: null,
      status: null,
      pagination: {currentPage: 1, pages:1},
      length_options:
          [
            { value: 20, text: "20" },
            { value: 50, text: "50" },
            { value: 100, text: "100" },
            { value: 500, text: "500" },
            { value: 1500, text: "1500" },
          ],
      temp_length: 100,
    };
  },
  methods: {
  moment,
    formatDate(date) {
      return new Date(date).toLocaleDateString('en-US', {
        weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
      });
    },
    setFilter : function()
    {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-filter');
    },
    resetFilter : function()
    {
      this.shift = null;
      this.status = null;
      this.$root.$emit('bv::toggle::collapse', 'sidebar-filter');
    },
    showEmployee(data){
      if(data.activity_log && Array.isArray(data.activity_log) && data.activity_log.length > 0)
      {
        this.activity_log = (data.activity_log || []).slice().sort((a, b) => {
          return new Date(a.time) - new Date(b.time);
        });
        this.check_in = data.check_in;
        this.check_out = data.check_out;
        this.work_time = data.work_time;
        this.break_time = data.break_time;
        this.over_time = data.over_time;
        this.attendances_date = data.period_date;
        this.shift_name = `${data.shift.name} (${data.shift.start_time} - ${data.shift.end_time})`;
        this.shift_color = data.shift.color;
        this.$bvModal.show('activity_logModal');
      }
    },
    loadData(date) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        return false;
      }
      this.error = null;
      this.loading = true;

      const formData = new FormData();
      formData.append('date', date);
      formData.append('download', 0);

      axios.post(this.$api_url + '/leave-attendance/daily', formData). then(response => {
        this.assignments = response.data;
        this.loading = false;
        this.errors = [];
      }).catch(e => this.serverError(e)).finally(()=>{this.loading = false;});

    },
    downloadData(date) {
      this.error = null;
      this.loading = true;

      const formData = new FormData();
      formData.append('date', date);
      formData.append('download', 1);

      axios.post(this.$api_url + '/leave-attendance/daily', formData,{responseType: 'blob'}). then(response => {
        this.global_download_file_content(response);
      }).catch(e => this.serverError(e)).finally(()=>{this.loading = false;});

    },

    openModal() {
      this.$bvModal.show('bv-modal-import-roster');
      this.selectedFile = null
    },

    closeModal() {
      this.$bvModal.hide('bv-modal-import-roster');
      this.selectedFile = null
    },

    onFileChange(event) {
      if(!this.checkFileType(event , 'datafile', ['.csv', '.xls', '.xlsx'])) return;
      this.selectedFile = event;
    },

    openAttendanceFileModal() {
      this.$bvModal.show('bv-modal-import-attendance');
      this.selectedFile = null
    },

    importFile(k=0) {
      if (!this.selectedFile) return;

      this.$bvToast.toast('You attendance data is importing.', {
        title: 'Hang Tight!',
        variant: 'success',
        solid: true,
      })

      let formData = new FormData();
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      formData.append('template', this.selectedFile);
      formData.append('k', k);
      this.loading = true;
      axios.post(this.$api_url + '/leave-attendance/attendance/template/import', formData, config).then(response => {
        if(response.data.errors) {
          this.errors = response.data.errors;
          this.loading = false;
        }
        else {
          this.errors = [];
          this.$bvToast.toast(response.data.message,{
            solid: true,
            title: 'Success',
            variant: 'success'
          });
          this.loadData(this.date);
          this.loading = false;
        }
      }).catch(e => {
        this.serverError(e);
        this.loading = false;
      });

      this.closeModal()
    },
    downloadTemplate(type, selected=[],date = '') {
      let params = {};
      if(date != '') {
        params = {date: date};
      }
      if(type == 1 && selected.length == 0) {
        this.$bvToast.toast('Please select employee(s) to download', {
          variant: 'danger',
          title: 'Failed',
          solid: true,
        });
        return;
      }
      if(selected.length > 0) {
        params.selected = JSON.stringify(selected);
      }
      this.$bvToast.toast('Your attendance template is downloading.', {
        title: 'Downloading',
        variant: 'success',
        solid: true,
      });
      this.loading = true;
      axios.get(this.$api_url + '/leave-attendance/attendance/template/download', {
        params : params, responseType: 'blob'
      }).then(response => {
        this.global_download_file_content(response);
        this.loading = false;
      }).catch(e => {
        this.serverError(e);
        this.loading = false;
      });
    },
    loadShifts() {
      this.loading = true
      axios.get('/leave-attendance/shifts').then((response) => {
        this.shifts = response.data;
      }).catch(error => {
        this.serverError(error)
      });
    },
  },
  computed: {
    statusOptions() {
        const defaultStatuses = [
        'Scheduled',
        'Present',
        'Absent',
        'Late',
        'Early Out',
        'Late & Early Out',
        'On Leave',
        'Leave Pending',
        'Leave Rejected',
        'Holiday',
        'Off Day',
        'Compensatory Off',
        'Swapped',
        'Overtime',
        'Unassigned'
        ];
        const set = new Set(defaultStatuses);
        if (this.assignments && this.assignments.length) {
        this.assignments.forEach((row) => {
            if (row.status) {
            set.add(row.status);
            }
        });
        }
        return Array.from(set).map((s) => ({ value: s, text: s }));
    },
    selectAll: {
      get: function () {
        if(this.selected.length == 0) return false;
        return this.paginatedData ? this.selected.length == this.paginatedData.length : false;
      },
      set: function (value) {
        let selected = [];
        if (value) {
          this.paginatedData.forEach(function (val) {
            selected.push(val.id);
          });
        }
        this.selected = selected;
      }
    },
    filteredData()
    {
      let filtered_list = this.assignments;
      if (this.search)
      {
        filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
      }

      if(this.shift != null) {
        filtered_list = filtered_list.filter((row) => {return row.shift_id == this.shift});
      }

      if(this.status != null) {
        filtered_list = filtered_list.filter((row) => {return row.status == this.status});
      }

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey)
      {
        filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
              a = String(a[sortKey]).toLowerCase();
              b = String(b[sortKey]).toLowerCase();
              if (this.columns[index].type && this.columns[index].type == 'date')
              {
                return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
              }
              else if (this.columns[index].type && this.columns[index].type == 'number')
              {
                return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
              }
              else
              {
                return (a == b ? 0 : a > b ? 1 : -1) * order;
              }
            }
        );
      }
      return filtered_list;
    },
    paginatedData()
    {
      return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
    },

  },
  mounted() {
    this.loadData(this.date);
    this.loadShifts();
    if(this.roster == 0)
    {
      this.columns = this.columns.filter(column => !['shift_name', 'shift_time'].includes(column.name));
    }
  },
};
</script>
